import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function ShardingAndPartitioning() {
    return (
        <TopicLayout
            title="Sharding & partitioning"
            intro="Splitting a dataset across multiple nodes so no single machine holds — or serves — all of it. The partitioning strategy determines how evenly load spreads and how painful adding shards later will be."
            diagram={
                <Diagram viewBox="0 0 560 220">
                    <text x={95} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Hash-based</text>
                    <Box x={40} y={28} width={110} height={30} label="key: user:42"/>
                    <Box x={45} y={90} width={100} height={30} label="hash() % N" accent/>
                    <Box x={15} y={150} width={50} height={30} label="S0"/>
                    <Box x={70} y={150} width={50} height={30} label="S1" accent/>
                    <Box x={125} y={150} width={50} height={30} label="S2"/>
                    <Arrow x1={95} y1={58} x2={95} y2={90}/>
                    <Arrow x1={95} y1={120} x2={95} y2={150}/>
                    <text x={95} y={198} textAnchor="middle" fontSize={11} opacity={0.7}>even spread, hard to resize</text>

                    <line x1={185} y1={10} x2={185} y2={210} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={278} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Range-based</text>
                    <Box x={200} y={90} width={50} height={30} label="A–H"/>
                    <Box x={253} y={90} width={50} height={30} label="I–P"/>
                    <Box x={306} y={90} width={50} height={30} label="Q–Z"/>
                    <Box x={200} y={150} width={50} height={30} label="S0"/>
                    <Box x={253} y={150} width={50} height={30} label="S1" accent/>
                    <Box x={306} y={150} width={50} height={30} label="S2"/>
                    <Arrow x1={225} y1={120} x2={225} y2={150}/>
                    <Arrow x1={278} y1={120} x2={278} y2={150}/>
                    <Arrow x1={331} y1={120} x2={331} y2={150}/>
                    <text x={278} y={198} textAnchor="middle" fontSize={11} opacity={0.7}>easy scans, hot-shard risk</text>

                    <line x1={375} y1={10} x2={375} y2={210} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={465} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Directory-based</text>
                    <Box x={410} y={28} width={110} height={30} label="key: user:42"/>
                    <Box x={405} y={90} width={120} height={34} label="Lookup table" accent/>
                    <Box x={425} y={150} width={80} height={30} label="Shard N"/>
                    <Arrow x1={465} y1={58} x2={465} y2={90}/>
                    <Arrow x1={465} y1={124} x2={465} y2={150} label="any mapping"/>
                    <text x={465} y={198} textAnchor="middle" fontSize={11} opacity={0.7}>flexible, lookup is an extra hop</text>
                </Diagram>
            }
            useWhen={[
                'Hash-based: writes should spread evenly and range scans across keys are not a priority.',
                'Range-based: queries commonly scan a contiguous range of keys, such as time-series data by timestamp.',
                'Directory-based: shard assignment needs to be arbitrary or change without rehashing everything, at the cost of an extra lookup and a new single point of failure to protect.'
            ]}
            tradeOff="A good shard key spreads both storage and request load evenly; a bad one creates a hot shard that dominates latency no matter how many shards exist. Hash-based partitioning spreads load well but scatters range queries across every shard and makes adding shards without a consistent-hashing scheme mean moving most of the data. Range-based partitioning keeps related data together but concentrates writes on whichever range is currently active. Resharding — splitting or merging partitions as data grows — is operationally the hardest part of any of these and should be designed for from day one."
            ruleOfThumb="Pick the shard key from the dominant access pattern, not convenience; favor hash-based partitioning (or consistent hashing) by default, and only reach for range-based partitioning when range scans are a first-class requirement."
        />
    )
}
